// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__M7tgC","loadingWithClose":"style_loadingWithClose__88sIi"};